import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/auth/AuthContext";

export function useBspAgencyData(destinationCode, enabled = true, sourceMarket = "FR") {
  const { activeOrgId } = useAuth();
  const [state, setState] = useState({ scope: null, loading: false, data: null });

  useEffect(() => {
    let cancelled = false;
    if (!enabled || !activeOrgId || !destinationCode) {
      setState({ scope: null, loading: false, data: null });
      return undefined;
    }
    const scope = `${activeOrgId}:${sourceMarket}:${destinationCode}`;
    setState({ scope, loading: true, data: null });
    api.get(`/bsp-data/agencies/${destinationCode}`, {
      params: { source_market: sourceMarket },
      headers: { "X-Organization-ID": activeOrgId },
    }).then(({ data }) => {
      if (!cancelled) setState({ scope, loading: false, data });
    }).catch(() => {
      if (!cancelled) setState({ scope, loading: false, data: null });
    });
    return () => { cancelled = true; };
  }, [activeOrgId, destinationCode, enabled, sourceMarket]);

  const scope = `${activeOrgId}:${sourceMarket}:${destinationCode}`;
  return state.scope === scope ? { loading: state.loading, data: state.data } : { loading: enabled, data: null };
}
